/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalityarchetypelabelleader3Inputs */



/**
* | output |
* | --- |
* | "The Captain of the Crew" |
*
* @param {Personalityarchetypelabelleader3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalityarchetypelabelleader3 = /** @type {((inputs?: Personalityarchetypelabelleader3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalityarchetypelabelleader3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The Captain of the Crew")
	if (locale === "es") return /** @type {LocalizedString} */ ("El Capitan del Grupo")
	return /** @type {LocalizedString} */ ("Капитан движухи")
});
export { personalityarchetypelabelleader3 as "personalityArchetypeLabelLeader" }